export default "__VITE_ASSET__CxHa6so0__"